import React, { useState, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import api from '../../../services/api';

const Step2Personal = () => {
    const { mockUser, refreshUser } = useOutletContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [stateList, setStateList] = useState([]);

    const [formData, setFormData] = useState({
        candidateName: '', fatherName: '', motherName: '',
        dobDay: '0', dobMonth: '0', dobYear: '0', 
        gender: '0', 
        nationality: '01', // Default 01=Indian
        domicileState: '0', 
        category: '0', categoryConfirm: '0',
        isDiabetic: '2', // 1=Yes, 2=No
        placeOfResidence: '0',
        annualIncome: '0',
        isMinority: '2', 
        wardOfDefence: '02', // 01=Yes, 02=No
        nccQuota: '02',
        sportsQuota: '02',
        captcha: ''
    });

    // Load Initial Data
    useEffect(() => {
        const init = async () => {
            try {
                // 1. Fetch States Lookup
                const stateRes = await api.get('/mock-cuet/states');
                if (stateRes.data.success) setStateList(stateRes.data.data);

                // 2. Fetch User Data from DB
                const res = await api.get(`/mock-cuet/application-data?mockAppId=${mockUser.id}`);
                if (res.data.success) {
                    const dbData = res.data.data;
                    
                    // --- FIX 1: Robust Date Parsing (Avoid Timezones) ---
                    let d = '0', m = '0', y = '0';
                    if (dbData.dob) {
                        // Take the date part only (YYYY-MM-DD), ignore time
                        // This handles both "1980-09-13" and "1980-09-13T00:00:00.000Z"
                        const dateStr = dbData.dob.toString().split('T')[0]; 
                        const parts = dateStr.split('-');
                        if(parts.length === 3) {
                            y = parts[0]; 
                            m = String(parseInt(parts[1])); // Removes leading 0 (e.g., '09' -> '9') to match <option value="9">
                            d = String(parseInt(parts[2])); // Removes leading 0
                        }
                    }

                    // --- FIX 2: Ensure Gender matches string '01' ---
                    const genderVal = dbData.gender ? String(dbData.gender).padStart(2, '0') : '0';

                    setFormData(prev => ({
                        ...prev,
                        candidateName: dbData.candidate_name || '',
                        fatherName: dbData.father_name || '',
                        motherName: dbData.mother_name || '',
                        
                        dobDay: d, dobMonth: m, dobYear: y,
                        
                        gender: genderVal,
                        nationality: dbData.nationality || '01',
                        domicileState: dbData.domicile_state || '0',
                        
                        category: dbData.category || '0',
                        categoryConfirm: dbData.category || '0',
                        
                        isDiabetic: dbData.is_diabetic === 1 ? '1' : '2',
                        placeOfResidence: dbData.place_of_residence || '0',
                        annualIncome: dbData.annual_income || '0',
                        isMinority: dbData.is_minority === 1 ? '1' : '2',
                        wardOfDefence: dbData.ward_of_defence === 1 ? '01' : '02',
                        nccQuota: dbData.ncc_quota === 1 ? '01' : '02',
                        sportsQuota: dbData.sports_quota === 1 ? '01' : '02'
                    }));
                }
            } catch (err) { console.error(err); }
        };
        init();
    }, [mockUser]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if(formData.category !== formData.categoryConfirm) {
            alert("Category and Confirm Category must match.");
            setLoading(false);
            return;
        }

        // --- FIX 3: Ensure Payload formats match DB expectations ---
        const payload = {
            ...formData,
            // Convert boolean-like strings back to integers for TINYINT
            isDiabetic: formData.isDiabetic === '1' ? 1 : 0,
            isMinority: formData.isMinority === '1' ? 1 : 0,
            wardOfDefence: formData.wardOfDefence === '01' ? 1 : 0,
            nccQuota: formData.nccQuota === '01' ? 1 : 0,
            sportsQuota: formData.sportsQuota === '01' ? 1 : 0,
        };

        try {
            const res = await api.post('/mock-cuet/save-step', {
                mockAppId: mockUser.id,
                stepNumber: 2,
                stepData: payload,
                nextStepNumber: 3
            });

            if (res.data.success) {
                refreshUser(3);
                navigate('/services/counselling/dashboard/pwd-details');
            }
        } catch (err) {
            alert("Error saving data");
        } finally {
            setLoading(false);
        }
    };

    // --- FIX 4: Year Range (1960 to 2011) ---
    // Generates [2011, 2010, ..., 1960]
    const yearOptions = [];
    for (let i = 2011; i >= 1960; i--) {
        yearOptions.push(i);
    }

    return (
        <div id="ctl00_ContentPlaceHolder1_pnlApplicationForm">
            <div className="appstatus" style={{ paddingTop: '0px', marginTop: '0px' }}>
                <div id="ctl00_ContentPlaceHolder1_pnlPersonalDetails">
                    <h4>
                        <span id="ctl00_ContentPlaceHolder1_lblPersonalDetailsSectionHeader">व्यक्तिगत विवरण(Personal Details)</span>
                    </h4>
                    
                    <form className="form-horizontal formLabel" onSubmit={handleSubmit}>
                        
                        {/* Name Fields (Read Only) */}
                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>अभ्यर्थी का नाम (Candidate's Name)</span></label>
                            <div className="col-sm-4">
                                <input name="candidateName" value={formData.candidateName} onChange={handleChange} type="text" className="form-control" readOnly />
                            </div>
                        </div>

                        {/* DOB Field - Fixed Range and Values */}
                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>अभ्यर्थी की जन्म तिथि (Candidate's Date of Birth)</span></label>
                            <div className="col-sm-2">
                                <select name="dobDay" value={formData.dobDay} onChange={handleChange} className="form-control" disabled>
                                    <option value="0">Day</option>
                                    {[...Array(31)].map((_,i) => <option key={i} value={String(i+1)}>{i+1}</option>)}
                                </select>
                            </div>
                            <div className="col-sm-2">
                                <select name="dobMonth" value={formData.dobMonth} onChange={handleChange} className="form-control" disabled>
                                    <option value="0">Month</option>
                                    {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'].map((m,i) => 
                                        <option key={i} value={String(i+1)}>{m}</option>
                                    )}
                                </select>
                            </div>
                            <div className="col-sm-2">
                                <select name="dobYear" value={formData.dobYear} onChange={handleChange} className="form-control" disabled>
                                    <option value="0">Year</option>
                                    {yearOptions.map(y => (
                                        <option key={y} value={String(y)}>{y}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Gender - Fixed Values ('01', '02', '04') */}
                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>लिंग (Gender)</span></label>
                            <div className="col-sm-4">
                                <select name="gender" value={formData.gender} onChange={handleChange} className="form-control" disabled>
                                    <option value="0">--Select--</option>
                                    <option value="01">Male</option>
                                    <option value="02">Female</option>
                                    <option value="04">Third Gender</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>पिता / अभिभावक का नाम (Father's Name)</span></label>
                            <div className="col-sm-4">
                                <input name="fatherName" value={formData.fatherName} onChange={handleChange} type="text" className="form-control" readOnly />
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>माता / अभिभावक का नाम (Mother's Name)</span></label>
                            <div className="col-sm-4">
                                <input name="motherName" value={formData.motherName} onChange={handleChange} type="text" className="form-control" readOnly />
                            </div>
                        </div>

                        {/* Nationality */}
                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>राष्ट्रीयता (Nationality)</span></label>
                            <div className="col-sm-4">
                                <select name="nationality" value={formData.nationality} onChange={handleChange} className="form-control" required>
                                    <option value="01">Indian</option>
                                    <option value="02">Overseas Citizenship of India</option>
                                    <option value="04">Foreign (Other than OCI)</option>
                                    <option value="05">Non-Resident Indian</option>
                                </select>
                            </div>
                        </div>

                        {/* Domicile State */}
                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>राज्य का निवास (State of Domicile)</span></label>
                            <div className="col-sm-4">
                                <select name="domicileState" value={formData.domicileState} onChange={handleChange} className="form-control" required>
                                    <option value="0">--Select--</option>
                                    {stateList.map((st) => (
                                        <option key={st.state_code} value={st.state_code}>{st.state_name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Category */}
                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>श्रेणी (Category)</span></label>
                            <div className="col-sm-4">
                                <select name="category" value={formData.category} onChange={handleChange} className="form-control" required>
                                    <option value="0">--Select--</option>
                                    <option value="01">General</option>
                                    <option value="44">OBC- (Non Creamy Layer)</option>
                                    <option value="02">SC</option>
                                    <option value="03">ST</option>
                                    <option value="39">EWS</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>श्रेणी की पुष्टि करें (Confirm Category)</span></label>
                            <div className="col-sm-4">
                                <select name="categoryConfirm" value={formData.categoryConfirm} onChange={handleChange} className="form-control" required>
                                    <option value="0">--Select--</option>
                                    <option value="01">General</option>
                                    <option value="44">OBC- (Non Creamy Layer)</option>
                                    <option value="02">SC</option>
                                    <option value="03">ST</option>
                                    <option value="39">EWS</option>
                                </select>
                            </div>
                        </div>

                        {/* Diabetic */}
                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>क्या आपको मधुमेह हैं? Are You Diabetic?</span></label>
                            <div className="col-sm-4">
                                <select name="isDiabetic" value={formData.isDiabetic} onChange={handleChange} className="form-control">
                                    <option value="1">Yes</option>
                                    <option value="2">No</option>
                                </select>
                            </div>
                        </div>

                        {/* Place of Residence */}
                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>निवास की जगह (Place of Residence)</span></label>
                            <div className="col-sm-4">
                                <select name="placeOfResidence" value={formData.placeOfResidence} onChange={handleChange} className="form-control" required>
                                    <option value="0">--Select--</option>
                                    <option value="01">Urban</option>
                                    <option value="02">Rural</option>
                                </select>
                            </div>
                        </div>

                        {/* Income */}
                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>वार्षिक पारिवारिक आय (Annual Family Income)</span></label>
                            <div className="col-sm-4">
                                <select name="annualIncome" value={formData.annualIncome} onChange={handleChange} className="form-control" required>
                                    <option value="0">--Select--</option>
                                    <option value="01">UPTO 100000</option>
                                    <option value="02">RS. 100001 - 200000</option>
                                    <option value="03">RS. 200001 - 300000</option>
                                    <option value="04">RS. 300001 - 400000</option>
                                    <option value="05">RS. 400001 - 500000</option>
                                    <option value="06">RS. 500001 - 600000</option>
                                    <option value="07">RS. 600001 - 700000</option>
                                    <option value="08">RS. 700001 - 800000</option>
                                    <option value="09">RS. 800001 AND ABOVE</option>
                                </select>
                            </div>
                        </div>

                        {/* Minority */}
                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>अल्पसंख्यक के हैं (Belongs to Minority)</span></label>
                            <div className="col-sm-4">
                                <select name="isMinority" value={formData.isMinority} onChange={handleChange} className="form-control">
                                    <option value="0">--Select--</option>
                                    <option value="1">Yes</option>
                                    <option value="2">No</option>
                                </select>
                            </div>
                        </div>

                        {/* Special Categories */}
                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>रक्षा कार्मिक / भूतपूर्व सैनिकों के प्रतिपालित (Ward of Defence Personnel)</span></label>
                            <div className="col-sm-4">
                                <select name="wardOfDefence" value={formData.wardOfDefence} onChange={handleChange} className="form-control">
                                    <option value="01">Yes</option>
                                    <option value="02">No</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>एनसीसी कोटा के लिए दावा (Claim for NCC Quota)</span></label>
                            <div className="col-sm-4">
                                <select name="nccQuota" value={formData.nccQuota} onChange={handleChange} className="form-control">
                                    <option value="01">Yes</option>
                                    <option value="02">No</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="control-label col-sm-4"><span>खेल कोटा के लिए दावा (Claim for Sports Quota)</span></label>
                            <div className="col-sm-4">
                                <select name="sportsQuota" value={formData.sportsQuota} onChange={handleChange} className="form-control">
                                    <option value="01">Yes</option>
                                    <option value="02">No</option>
                                </select>
                            </div>
                        </div>

                        {/* Captcha */}
                        <h4>CAPTCHA</h4>
                        <div className="form-group">
                            <label className="control-label col-sm-4">Enter CAPTCHA</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" name="captcha" value={formData.captcha} onChange={handleChange} required />
                            </div>
                        </div>
                        <div className="form-group">
                             <label className="control-label col-sm-4"></label>
                             <div className="col-sm-4">
                                  <img src="/assets/cuet-mock/images/DisplayCaptchaImg.jpg" alt="Captcha" style={{height:'34px'}} />
                                  <img src="/assets/cuet-mock/images/Refresh.png" alt="Refresh" style={{height:'30px', marginLeft:'10px'}} />
                             </div>
                        </div>

                        {/* Buttons */}
                        <div className="row">
                            <div className="form-group">
                                <div className="col-sm-12 text-center">
                                    <button type="button" className="btn btn-warning" onClick={() => navigate('/services/counselling/dashboard/contact-details')} style={{marginRight:'10px'}}>
                                        Back
                                    </button>
                                    <button type="submit" value="Save & Next" className="btn btn-primary" disabled={loading}>
                                        {loading ? 'Saving...' : 'Save & Next'}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    );
};

export default Step2Personal;